import { Component } from '@angular/core';
import { UIHelpers } from '../../core/ui-helpers';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-style-page',
  templateUrl: './style-page.component.html',
  standalone: false,
})
export class StylePageComponent extends BasePage {
  constructor(public uiHelpers: UIHelpers) {
    super();
  }

  public jumpToSection(selector: string) {
    UIHelpers.scrollToTop(selector);
  }
}
